import { useIntl } from 'react-intl';

import type { TemplateIssue } from '@/entities/templates';

import { i18n } from '../config';
import type { TemplateIssuePlace } from '../lib';

// A template issue in the interface language: what is wrong, by its kind,
// and where, as the clinician counts the template's sections and lines.
export const useTemplateIssueText = () => {
  const { formatMessage } = useIntl();

  const describe = (issue: TemplateIssue) =>
    formatMessage(
      i18n.templateIssueMessages[issue.Kind] ??
        i18n.templateIssueFallbackMessage,
    );

  const describePlace = ({ sectionTitle, line }: TemplateIssuePlace) =>
    line === undefined
      ? formatMessage(
          {
            id: 'workspace.templateIssue.placeSection',
            defaultMessage: 'Section “{section}”',
          },
          { section: sectionTitle },
        )
      : formatMessage(
          {
            id: 'workspace.templateIssue.placeLine',
            defaultMessage: 'Section “{section}”, line {line}',
          },
          { section: sectionTitle, line },
        );

  return { describe, describePlace };
};
